import { Button } from "components/atoms/Button";

interface BulkEquipmentUploadModalFooterProps {
    onSave: () => void;
    onCancel: () => void;
    isLoading: boolean;
    disabled: boolean;
}

function BulkEquipmentUploadModalFooter({
    onSave,
    onCancel,
    isLoading,
    disabled,
}: BulkEquipmentUploadModalFooterProps) {
    return (
        <div className="bulk-edit-tags__footer" style={{ marginTop: "30px" }}>
            <Button type="primary" onClick={onSave} disabled={disabled}>
                {!isLoading ? "Upload CSV" : "Loading..."}
            </Button>
            <Button type="link" onClick={onCancel} style={{ color: "var(--audette-black)" }}>
                Close
            </Button>
        </div>
    );
}

export default BulkEquipmentUploadModalFooter;
